import { RHSR_LOGO } from '@generated/components/AdGuide';

/** Use the square RHSR logo as the browser tab icon and the phone home-screen icon. */
export function applyAppIcon() {
  const set = (rel: string, attrs: Record<string, string> = {}) => {
    document.querySelectorAll(`link[rel="${rel}"]`).forEach((l) => l.remove());
    const l = document.createElement('link');
    l.rel = rel; l.href = RHSR_LOGO;
    Object.entries(attrs).forEach(([k, v]) => l.setAttribute(k, v));
    document.head.appendChild(l);
  };
  set('icon', { type: 'image/png' });
  set('apple-touch-icon', { sizes: '180x180' });
  const meta = (name: string, content: string) => {
    let m = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!m) { m = document.createElement('meta'); m.name = name; document.head.appendChild(m); }
    m.content = content;
  };
  meta('apple-mobile-web-app-title', 'Star-Revue');
  meta('application-name', 'Star-Revue');
}
